/**
 * Global handler for auth-related HTTP failures (401/403).
 *
 * Called from API/store call sites after a fetch response comes back, this
 * inspects the response for an auth failure and, instead of notifying/logging
 * out per call site, routes it through the shared `sessionExpired` circuit
 * breaker so the user sees a single session-expired popup regardless of how
 * many in-flight requests failed.
 */

// OLD: import store from '@/store';
// OLD: import { showNotification } from '@/plugins/notification';
import { triggerSessionExpired } from './sessionExpired';

/**
 * Checks an API response for a 401/403 auth failure and, if found, trips the
 * shared session-expired state.
 *
 * A `403` with code `403021` (account deleted) shows its own message; any
 * other `401`/`403` triggers the default session-expired message. Anything
 * else is ignored (returns undefined, no-op).
 *
 * @param {object} response Response-like object with `status`/`statusCode` and optionally `code`.
 */
export async function authErrorHandler(response) {
  let error = response?.status || response?.statuscCode;

  // OLD:
  // if (error === 401) {
  //   showNotification('error', `Error ${error}`, 'Session expired. Please log in to continue.', 5000);
  //   store.dispatch('logOut', error);
  // }
  // if (error === 403 && response.code === 403021) {
  //   showNotification(
  //     'error',
  //     `Error ${error}`,
  //     'This account no longer exists. Contact support for help, or log out to return to the home screen.',
  //     5000,
  //   );
  //   store.dispatch('logOut', error);
  // }

  // NEW: account-deleted keeps its own message; any other 401/403 trips the
  // shared session-expired popup instead of notifying + logging out per call.
  if (error === 403 && response?.code === 403021) {
    triggerSessionExpired('This account no longer exists. Contact support for help, or log out to return to the home screen.');
    return;
  }
  if (error === 401 || error === 403) {
    triggerSessionExpired();
  }
}
